module.exports = __webpack_public_path__ + "img/Discord_icon.44d854a6.svg";